// ── Starter templates + output-object text for value_body (pure) ─────────
import { columnRef, isIdentifier } from './columnRef.js';

// Object-literal key for an output name (a plain key when it is an
// identifier, a quoted string otherwise). The server's static key check
// reads either form.
export function objectKey(name) {
  const s = String(name);
  return isIdentifier(s) ? s : JSON.stringify(s);
}

// `{ a: «value», b: «value» }` spread over lines; `fill` is what goes after
// each colon (a «placeholder» by default).
export function outputObject(names, fill = '«value»', indent = '  ') {
  const list = (names || []).filter(n => String(n).trim() !== '');
  if (!list.length) return '{}';
  return '{\n' + list.map((n) => `${indent}${objectKey(n)}: ${fill}`).join(',\n') + '\n}';
}

// The column the starter and the snippets default to: the first real input
// column (bookkeeping keys id / __rowIndex are skipped when anything else is
// known). Falls back to a generic "column" when no columns are known.
export function firstColumnName(columns) {
  const names = (columns || []).map(c => (typeof c === 'string' ? c : c?.name)).filter(n => typeof n === 'string' && n !== '');
  const real = names.filter(n => n !== 'id' && n !== '__rowIndex');
  return (real[0] ?? names[0]) ?? 'column';
}

// A commented, valid body to open an empty editor with. It is only a draft
// until Apply. One output: scalar returns. Two or more: each return is an
// object keyed by the output names.
export function starterTemplate(names, firstCol = 'column') {
  const list = (names || []).filter(n => String(n).trim() !== '');
  const ref = columnRef(firstCol);
  const retVal = (first) => {
    if (list.length < 2) return JSON.stringify(first);
    return '{ ' + list.map((n, i) => `${objectKey(n)}: ${i === 0 ? JSON.stringify(first) : '""'}`).join(', ') + ' }';
  };
  return [
    '// Write the logic for each row. The first "return" that runs gives',
    '// the value for that row.',
    '// Edit the condition and the values below. Tip: click a column on the',
    '// left or a snippet on the right to insert it at the cursor.',
    `if (isBlank(${ref})) {`,
    `  return ${retVal('Unknown')};   // value when the condition is true`,
    '} else {',
    `  return ${retVal('Other')};     // value for everything else`,
    '}',
    '',
  ].join('\n');
}

// Indentation of the line containing `pos`.
export function lineIndent(text, pos) {
  const start = text.lastIndexOf('\n', Math.max(0, pos) - 1) + 1;
  const m = /^[ \t]*/.exec(text.slice(start));
  return m ? m[0] : '';
}

// Tab -> two spaces at the selection (no focus trap: caller decides when to
// let Tab through).
export function insertTab(text, selStart, selEnd) {
  return { text: text.slice(0, selStart) + '  ' + text.slice(selEnd), selStart: selStart + 2, selEnd: selStart + 2 };
}
